module.exports = __webpack_public_path__ + "static/media/loading.2df94b2c.gif";